module.exports = __webpack_public_path__ + "static/media/Analytics.e460e9de.svg";